import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _ExpValidationResultFactory;
/* eslint-disable */
/**
 * Expression Service
 * An API for Expression services, supporting the Expression Editor and Expression Evaluation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech) (v6.0.1).
 *
 * Do not edit the class manually.
 */

// InputSpec (yaml) file: /var/jenkins_home/workspace/V4-5-1-global-pipeline-all-web-products-build/webcommons/abweb/openapi/internal/typescript/target/openapi/openapi//abwebinternal/expressionservice.yaml
// Template file: models.mustache (typescript-fetch)

// @ts-ignore noUnusedLocals

/**
 * 
 * @export
 * @interface ExpValidationResult
 */

export class ExpValidationResultFactory {}
_ExpValidationResultFactory = ExpValidationResultFactory;
_defineProperty(ExpValidationResultFactory, "FromJSON", function (json) {
  return _ExpValidationResultFactory.FromJSONTyped(json, false);
});
_defineProperty(ExpValidationResultFactory, "FromJSONTyped", function (json, ignoreDiscriminator) {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    'nodeID': json['nodeID'],
    'status': json['status'],
    'message': json['message']
  };
});
_defineProperty(ExpValidationResultFactory, "ToJSON", function (value) {
  return _ExpValidationResultFactory.ToJSONTyped(false, value);
});
_defineProperty(ExpValidationResultFactory, "ToJSONTyped", function (ignoreDiscriminator, value) {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    'nodeID': value.nodeID,
    'status': value.status,
    'message': value.message
  };
});
//# sourceMappingURL=ExpValidationResult.js.map
